import { useEffect } from 'react';

const ThemeInitializer = () => {
    useEffect(() => {
        // Configura o tema verde ao iniciar a aplicação
        localStorage.setItem("dataColor", "green");
        document.documentElement.setAttribute("data-color", "green");
    }, []);

    return null; // Este componente não renderiza nada
};

export default ThemeInitializer;